import PrimaryRouter from "./app/router/PrimaryRouter";

function App() {
  
  return (
    <div className="App">
      <PrimaryRouter />
    </div>
  );
}

export default App;
